import React, { useRef } from 'react';
import { Skeleton } from '@landr/maestro';
import { getAssetImageAndSrcSet } from 'helpers/getAssetImageAndSrcSet';
import { t } from '@lingui/macro';
import useDetectTargetIsInsideViewport from 'hooks/useDetectTargetIsInsideViewport/useDetectTargetIsInsideViewport';
import * as Styled from './styled';
import { BackgroundImageFromAssetProps } from './types';

const BackgroundImageFromAsset: React.FC<BackgroundImageFromAssetProps> = ({
    image,
    filetype = 'jpg',
    bgPosition = 'centerCenter',
    dimensions = ['2x'],
    zoom = 1,
    isLoading = false,
    alt = t`Background Image`,
    lazyLoading = false,
    opacity = 1,
    objectFit = 'cover',
}) => {
    const ref = useRef(null);

    const isInViewport = useDetectTargetIsInsideViewport({ ref, offset: 200 });
    const isVisible = lazyLoading ? isInViewport : true;

    const { fullImage, srcSet } = getAssetImageAndSrcSet(
        image,
        filetype,
        dimensions,
        isVisible,
    );

    if (isLoading) {
        return (
            <>
                <Skeleton width="100%" height="100%" />
            </>
        );
    }

    return (
        <Styled.BackgroundImage
            ref={ref}
            alt={alt}
            bgPosition={bgPosition}
            src={isVisible ? fullImage : ''}
            srcSet={isVisible ? srcSet : ''}
            zoom={zoom}
            loading="lazy"
            opacity={opacity}
            objectFit={objectFit}
        />
    );
};

export default BackgroundImageFromAsset;
